import { SxStyleProp } from "theme-ui"

export const root: SxStyleProp = {
  variant: "table",
}
